import type { CSSProperties } from 'react';
import type { PrismTheme } from 'prism-react-renderer';
import type { ScrollDirection } from '../Cscrollable';

export const CABAL_PRISM_THEME: PrismTheme = {
  plain: {
    color: 'rgba(255, 255, 255, 0.85)',
    backgroundColor: 'transparent',
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: {
        color: 'rgba(255, 255, 255, 0.3)',
        fontStyle: 'italic',
      },
    },
    {
      types: ['keyword', 'builtin', 'tag'],
      style: { color: '#66FEC1' },
    },
    {
      types: ['string', 'char', 'inserted', 'template-string'],
      style: { color: '#F29F57' },
    },
    {
      types: ['number', 'constant', 'boolean'],
      style: { color: '#5B9EFF' },
    },
    {
      types: ['function', 'method'],
      style: { color: '#A78BFA' },
    },
    {
      types: ['class-name', 'type-name', 'maybe-class-name'],
      style: { color: '#FF7EB3' },
    },
    {
      types: ['attr-name'],
      style: { color: '#45E0C4' },
    },
    {
      types: ['attr-value'],
      style: { color: '#F29F57' },
    },
    {
      types: ['operator', 'punctuation'],
      style: { color: 'rgba(255, 255, 255, 0.5)' },
    },
    {
      types: ['variable', 'property'],
      style: { color: 'rgba(255, 255, 255, 0.85)' },
    },
    {
      types: ['regex', 'important'],
      style: { color: '#FDCB6E' },
    },
    {
      types: ['deleted'],
      style: { color: '#FF8A65' },
    },
  ],
};

export const ICON_BTN_SIZE = 32;
export const ICON_BTN_ICON_SIZE = 20;
export const ICON_BTN_RADIUS = 6;
export const ICON_BTN_CONTAINER_STYLE: CSSProperties = {
  width: ICON_BTN_SIZE,
  minWidth: ICON_BTN_SIZE,
};

export const CSS_VALUE_INHERIT = 'inherit';
export const DEFAULT_FONT_SIZE_PX = 15;
export const MIN_FONT_SIZE_PX = 11;
export const MAX_FONT_SIZE_PX = 22;
export const FONT_SIZE_STEP_PX = 1;
export const COMPACT_PREVIEW_LINE_LIMIT = 14;
export const COMPACT_PREVIEW_FONT_SIZE_PX = 16;
export const COMPACT_PREVIEW_LINE_HEIGHT = 1.5;
export const COMPACT_PREVIEW_DATA_NAME = 'compactPreview';
export const COMPACT_PREVIEW_PADDING = '8px 14px 32px';
export const CODE_LINE_CLASS = 'cmarkdowncode-line';
export const CODE_LINE_USER_SELECT: CSSProperties['userSelect'] = 'none';
export const DEFAULT_CODE_LANGUAGE = 'text';
export const DOCKERFILE_LANGUAGE_ID = 'dockerfile';
export const DOCKERFILE_FILENAME = 'Dockerfile';
export const DEFAULT_CODE_EXTENSION = 'txt';
export const CODE_DOWNLOAD_FILENAME_BASE = 'code';
export const CODE_DOWNLOAD_MIME_TYPE = 'text/plain;charset=utf-8';
export const CODE_METRIC_UNIT_SINGLE = 'line';
export const CODE_METRIC_UNIT_PLURAL = 'lines';
export const SCROLL_DIRECTION_VERTICAL: ScrollDirection = 'vertical';
export const SCROLL_DIRECTION_HORIZONTAL: ScrollDirection = 'horizontal';
export const CROSS_AXIS_OVERFLOW_VISIBLE = 'visible';
export const CODE_BLOCK_FADE_SIZE = 20;
export const CODE_BLOCK_MIN_WIDTH = '100%';
export const CODE_LINE_NUMBER_PADDING_RIGHT_PX = 12;
export const CODE_LINE_NUMBER_MIN_FONT_SIZE_PX = 11;
export const CODE_LINE_NUMBER_FONT_DELTA_PX = 2;
export const CODE_LINE_NUMBER_COLOR = 'rgba(255, 255, 255, 0.2)';
export const CODE_LINE_NUMBER_TEXT_ALIGN: CSSProperties['textAlign'] = 'right';
export const INLINE_CODE_BACKGROUND_OPACITY = 0.6;
export const INLINE_CODE_PADDING_X_PX = 6;
export const INLINE_CODE_PADDING_Y_PX = 2;
export const VISUAL_CONTENT_PADDING_PX = 16;
